// extracted by mini-css-extract-plugin
export default {"link":"fVJMbP","root":"QfnfVg","wrapper":"Ekciqh","container":"g3r6dd","bottom":"pvckQl","ribbon":"k8sKAC","top":"khHorc","label":"oQRToW"};